import * as i0 from '@angular/core';
import { Component, ContentChildren, NgModule, Input } from '@angular/core';
import * as i1 from '@angular/common';
import { CommonModule } from '@angular/common';
import { CapturumTemplateDirective, CapturumSharedModule } from '@capturum/ui/api';
function CapturumLayoutDetailsComponent_ng_container_5_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 7);
    i0.ɵɵelementContainer(2, 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "div", 9);
    i0.ɵɵelementContainer(4, 8);
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
  }
  if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.firstContentTemplate);
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r0.secondContentTemplate);
  }
}
function CapturumLayoutDetailsComponent_ng_template_6_Template(rf, ctx) {
  if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 10);
    i0.ɵɵelementContainer(1, 8);
    i0.ɵɵelementEnd();
  }
  if (rf & 2) {
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngTemplateOutlet", ctx_r2.firstContentTemplate);
  }
}
let CapturumHeaderComponent = /*#__PURE__*/(() => {
  class CapturumHeaderComponent {
    ngAfterContentInit() {
      this.templates.forEach(item => {
        switch (item.getType()) {
          case 'logo':
            this.contentTemplate = item.template;
            break;
          case 'content':
            this.logoTemplate = item.template;
            break;
        }
      });
    }
    static {
      this.ɵfac = function CapturumHeaderComponent_Factory(t) {
        return new (t || CapturumHeaderComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumHeaderComponent,
        selectors: [["cap-header"]],
        contentQueries: function CapturumHeaderComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, CapturumTemplateDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
          }
        },
        decls: 5,
        vars: 2,
        consts: [[1, "header"], [1, "header__logo"], [3, "ngTemplateOutlet"], [1, "header__inner"]],
        template: function CapturumHeaderComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "header", 0)(1, "div", 1);
            i0.ɵɵelementContainer(2, 2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementStart(3, "div", 3);
            i0.ɵɵelementContainer(4, 2);
            i0.ɵɵelementEnd()();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.logoTemplate);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.contentTemplate);
          }
        },
        dependencies: [i1.NgTemplateOutlet],
        styles: ["[_ngcontent-%COMP%]:root{--cap-input-height: 30px;--cap-dynamic-filter-input-height: 30px;--cap-dynamic-filter-border-radius: 5px;--cap-dynamic-filter-border-width: 1px;--cap-dynamic-filters-hide-filters-on-mobile: false;--cap-dynamic-filters-filter-flex: 1;--cap-dynamic-filters-flex-wrap: wrap;--cap-dynamic-filter-width: 200px;--cap-dynamic-filter-label-font-size: 14px;--cap-dynamic-filter-label-font-weight: 600;--cap-dynamic-filter-label-font-family: \"Source Sans Pro\";--cap-dynamic-filter-label-font-color: #5f6062;--cap-dynamic-filter-placeholder-font-weight: 600;--cap-dynamic-filter-placeholder-font-color: #5f6062;--cap-dynamic-filter-icon-opacity: 1;--cap-dynamic-filter-icon-color: var(--cap-primary-color)}.header[_ngcontent-%COMP%]{background:#fff;height:103px;padding-left:75px;padding-right:42px;display:flex;align-items:center;box-shadow:0 5px 13px #0000001a}.header__logo[_ngcontent-%COMP%]{width:133px;height:30px}.header__logo[_ngcontent-%COMP%]     img{width:100%;height:100%}.header__inner[_ngcontent-%COMP%]{flex-grow:1;display:flex;justify-content:flex-end;align-items:center}.header__inner[_ngcontent-%COMP%]     cap-button .cap-button{margin-right:20px}.header__inner[_ngcontent-%COMP%]     cap-button:last-child .cap-button{margin-right:0}.header__col[_ngcontent-%COMP%]{display:flex;align-items:center}.header__icon[_ngcontent-%COMP%]{margin-left:69px;cursor:pointer;color:var(--cap-primary-color)}.header__col--last[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:center}.header__col--middle[_ngcontent-%COMP%]{display:flex;align-items:center;justify-content:space-between}@media (max-width: 575.98px){.header[_ngcontent-%COMP%]{flex-direction:column;height:100%;padding:0 20px}.header[_ngcontent-%COMP%]   div[_ngcontent-%COMP%]{margin-bottom:15px}.header__inner[_ngcontent-%COMP%]{width:100%;justify-content:space-between}.header__icon[_ngcontent-%COMP%]{margin-left:0}}"]
      });
    }
  }
  return CapturumHeaderComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumHeaderModule = /*#__PURE__*/(() => {
  class CapturumHeaderModule {
    static {
      this.ɵfac = function CapturumHeaderModule_Factory(t) {
        return new (t || CapturumHeaderModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumHeaderModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CapturumSharedModule, CommonModule]
      });
    }
  }
  return CapturumHeaderModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumHeadlineComponent = /*#__PURE__*/(() => {
  class CapturumHeadlineComponent {
    constructor() {
      this.title = 'Page Title';
    }
    static {
      this.ɵfac = function CapturumHeadlineComponent_Factory(t) {
        return new (t || CapturumHeadlineComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumHeadlineComponent,
        selectors: [["cap-headline"]],
        inputs: {
          contentTemplate: "contentTemplate",
          title: "title"
        },
        decls: 4,
        vars: 2,
        consts: [[1, "headline"], [1, "headline__title"], [3, "ngTemplateOutlet"]],
        template: function CapturumHeadlineComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "h1", 1);
            i0.ɵɵtext(2);
            i0.ɵɵelementEnd();
            i0.ɵɵelementContainer(3, 2);
            i0.ɵɵelementEnd();
          }
          if (rf & 2) {
            i0.ɵɵadvance(2);
            i0.ɵɵtextInterpolate(ctx.title);
            i0.ɵɵadvance(1);
            i0.ɵɵproperty("ngTemplateOutlet", ctx.contentTemplate);
          }
        },
        dependencies: [i1.NgTemplateOutlet],
        styles: [".headline[_ngcontent-%COMP%]{display:flex;height:88px;align-items:center;justify-content:space-between;border-bottom:solid 1px #ddd}.headline__title[_ngcontent-%COMP%]{font-size:toRem(16px)}"]
      });
    }
  }
  return CapturumHeadlineComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumHeadlineModule = /*#__PURE__*/(() => {
  class CapturumHeadlineModule {
    static {
      this.ɵfac = function CapturumHeadlineModule_Factory(t) {
        return new (t || CapturumHeadlineModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumHeadlineModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, CapturumSharedModule]
      });
    }
  }
  return CapturumHeadlineModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumLayoutDetailsComponent = /*#__PURE__*/(() => {
  class CapturumLayoutDetailsComponent {
    isContentWithTwoColumns() {
      return !!this.firstContentTemplate && !!this.secondContentTemplate;
    }
    ngAfterContentInit() {
      this.templates.forEach(item => {
        switch (item.getType()) {
          case 'first-content':
            this.firstContentTemplate = item.template;
            break;
          case 'second-content':
            this.secondContentTemplate = item.template;
            break;
          case 'header':
            this.headlineTemplate = item.template;
            break;
        }
      });
    }
    static {
      this.ɵfac = function CapturumLayoutDetailsComponent_Factory(t) {
        return new (t || CapturumLayoutDetailsComponent)();
      };
    }
    static {
      this.ɵcmp = /* @__PURE__ */i0.ɵɵdefineComponent({
        type: CapturumLayoutDetailsComponent,
        selectors: [["cap-layout-details"]],
        contentQueries: function CapturumLayoutDetailsComponent_ContentQueries(rf, ctx, dirIndex) {
          if (rf & 1) {
            i0.ɵɵcontentQuery(dirIndex, CapturumTemplateDirective, 4);
          }
          if (rf & 2) {
            let _t;
            i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.templates = _t);
          }
        },
        inputs: {
          title: "title"
        },
        decls: 8,
        vars: 4,
        consts: [[1, "page"], [1, "page__main", "main"], [1, "main__headline", 3, "contentTemplate", "title"], [1, "main__content"], [1, "row"], [4, "ngIf", "ngIfElse"], ["contentWithOneColumn", ""], [1, "main__col", "main__col--left", "col-md-6"], [3, "ngTemplateOutlet"], [1, "main__col", "main__col--right", "col-md-6"], [1, "main__col", "col"]],
        template: function CapturumLayoutDetailsComponent_Template(rf, ctx) {
          if (rf & 1) {
            i0.ɵɵelementStart(0, "div", 0)(1, "main", 1);
            i0.ɵɵelement(2, "cap-headline", 2);
            i0.ɵɵelementStart(3, "div", 3)(4, "div", 4);
            i0.ɵɵtemplate(5, CapturumLayoutDetailsComponent_ng_container_5_Template, 5, 2, "ng-container", 5);
            i0.ɵɵtemplate(6, CapturumLayoutDetailsComponent_ng_template_6_Template, 2, 1, "ng-template", null, 6, i0.ɵɵtemplateRefExtractor);
            i0.ɵɵelementEnd()()()();
          }
          if (rf & 2) {
            const _r1 = i0.ɵɵreference(7);
            i0.ɵɵadvance(2);
            i0.ɵɵproperty("contentTemplate", ctx.headlineTemplate)("title", ctx.title);
            i0.ɵɵadvance(3);
            i0.ɵɵproperty("ngIf", ctx.isContentWithTwoColumns())("ngIfElse", _r1);
          }
        },
        dependencies: [i1.NgIf, i1.NgTemplateOutlet, CapturumHeadlineComponent],
        styles: ["[_ngcontent-%COMP%]:root{--cap-input-height: 30px;--cap-dynamic-filter-input-height: 30px;--cap-dynamic-filter-border-radius: 5px;--cap-dynamic-filter-border-width: 1px;--cap-dynamic-filters-hide-filters-on-mobile: false;--cap-dynamic-filters-filter-flex: 1;--cap-dynamic-filters-flex-wrap: wrap;--cap-dynamic-filter-width: 200px;--cap-dynamic-filter-label-font-size: 14px;--cap-dynamic-filter-label-font-weight: 600;--cap-dynamic-filter-label-font-family: \"Source Sans Pro\";--cap-dynamic-filter-label-font-color: #5f6062;--cap-dynamic-filter-placeholder-font-weight: 600;--cap-dynamic-filter-placeholder-font-color: #5f6062;--cap-dynamic-filter-icon-opacity: 1;--cap-dynamic-filter-icon-color: var(--cap-primary-color)}.main[_ngcontent-%COMP%]{padding-left:75px;padding-right:42px}.main__title[_ngcontent-%COMP%]{font-size:1rem;font-weight:700;color:var(--primary-text)}.main__col[_ngcontent-%COMP%]{margin-top:26px}.main__col--left[_ngcontent-%COMP%]{margin-top:26px;border-right:solid 1px #ddd;height:60vh;padding-right:42px}.main__col--right[_ngcontent-%COMP%]{margin-top:26px;padding-left:42px}@media (max-width: 575.98px){.main[_ngcontent-%COMP%]{padding:0 20px}.main__col[_ngcontent-%COMP%]{height:100%;padding:0}.row[_ngcontent-%COMP%]{margin:0;width:100%}.main__col--left[_ngcontent-%COMP%]{border:none}}"]
      });
    }
  }
  return CapturumLayoutDetailsComponent;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumLayoutDetailsModule = /*#__PURE__*/(() => {
  class CapturumLayoutDetailsModule {
    static {
      this.ɵfac = function CapturumLayoutDetailsModule_Factory(t) {
        return new (t || CapturumLayoutDetailsModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumLayoutDetailsModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CommonModule, CapturumSharedModule, CapturumHeadlineModule]
      });
    }
  }
  return CapturumLayoutDetailsModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();
let CapturumLayoutModule = /*#__PURE__*/(() => {
  class CapturumLayoutModule {
    static {
      this.ɵfac = function CapturumLayoutModule_Factory(t) {
        return new (t || CapturumLayoutModule)();
      };
    }
    static {
      this.ɵmod = /* @__PURE__ */i0.ɵɵdefineNgModule({
        type: CapturumLayoutModule
      });
    }
    static {
      this.ɵinj = /* @__PURE__ */i0.ɵɵdefineInjector({
        imports: [CapturumSharedModule, CapturumHeaderModule, CapturumHeadlineModule, CapturumLayoutDetailsModule]
      });
    }
  }
  return CapturumLayoutModule;
})();
(function () {
  (typeof ngDevMode === "undefined" || ngDevMode) && void 0;
})();

/**
 * Generated bundle index. Do not edit.
 */

export { CapturumHeaderComponent, CapturumHeaderModule, CapturumHeadlineComponent, CapturumHeadlineModule, CapturumLayoutDetailsComponent, CapturumLayoutDetailsModule, CapturumLayoutModule };
